<ng-container *ngIf="pageGroup.length > 0">
    <div class="content">
        <img src="assets/images/basecamp.png" />
    </div>
</ng-container>